import React, { Fragment, useEffect, useRef, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import Cheque from "../../../components/Cheque"

import { httpOk, GET, PUT } from 'helpers/api'
import { formatDate, formatMoney, findKeyFromArrayByValue, regexPhoneNumber } from 'helpers/helpers'
import { useReactToPrint } from "react-to-print"

import { ProductType1, ProductType3, ProductType4, ProductType5 } from "./product_types"
import CustomTooltip from "pages/parts/CustomTooltip"

function Index() {
	const { t } = useTranslation()
	const date = new Date()

	const printChequeRef = useRef(null);

	const handlePrint = useReactToPrint({
		content: () => printChequeRef.current,
	});

	const productImages = [
		{
			id: 1,
			image: <ProductType1 />,
		},
		{
			id: 3,
			image: <ProductType3 />,
		},
		{
			id: 4,
			image: <ProductType4 />,
		},
		{
			id: 5,
			image: <ProductType5 />,
		},
	]

	const statuses = [
		{ 'id': 1, 'name': t('open') },
		{ 'id': 10, 'name': t('closed') },
		{ 'id': -1, 'name': t('deleted') },
	]

	const chequeTypes = [
		{ 'id': 'loyalty', 'name': t('loyalty') },
		{ 'id': 'debt', 'name': t('debt') },
		{ 'id': 'discount', 'name': t('discount') },
		{ 'id': 'bool_no_profit', 'name': t('no_profit') },
		{ 'id': 'bool_no_service_percentage', 'name': t('no_service_percentage') },
		{ 'id': 'organizations', 'name': t('organization') },
	]

	const chequeDates = [
		{ 'id': 'today', 'name': t('today') },
		{ 'id': 'currentWeek', 'name': t('current_week') },
		{ 'id': 'currentMonth', 'name': t('current_month') },
		{ 'id': 'currentYear', 'name': t('current_year') },
		{ 'id': 'yesterday', 'name': t('yesterday') },
		{ 'id': 'lastWeek', 'name': t('last_week') },
		{ 'id': 'lastMonth', 'name': t('last_month') },
		{ 'id': 'lastYear', 'name': t('last_year') },
		{ 'id': 'other', 'name': t('other') }, // Для "Другой..."
	];

	const [couriers, setCouriers] = useState([])
	const [paymentTypes, setPaymentTypes] = useState([])
	const [productStatuses, setProductStatuses] = useState([])
	const [clients, setClients] = useState([])
	const [printData, setPrintData] = useState({})

	const [modalStatuses, setModalStatuses] = useState({ show: false, item: {} })
	const [modalCouriers, setModalCouriers] = useState({ show: false, item: {} })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	// const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		start_date: formatDate(new Date(), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		// status: 10,
		random: 0,
		search: '',
	})
	const [pagination, setPagination] = useState({
		url: '/cheques',
		response: null
	})
	const [data, setData] = useState([])

	async function printCheque(item, a4 = false) {
		const response = await GET(`/cheques/${item.id}`, {}, { loader: true })
		if (httpOk(response)) {
			response.data.a4 = a4;
			setPrintData(response.data);
			setTimeout(() => {
				handlePrint()
			}, 100);
		}
	}

	async function searchWithFilter() {
		var filterDataCopy = { ...filterData }
		checkFilter()

		const response = await GET("/workshop-cheques", filterData, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterData.url, 'response': response.data })
		}

		setFilterData(filterDataCopy)
		setDropdownIsOpen(false)
	}

	function toggleModalStatuses(bool, item, item2 = {}) {
		if (bool) {
			if (item2.product_type_id) {
				item.product_type = item2.product_type_id;
			}
			setModalStatuses({ ...modalStatuses, show: true, item: item })

		} else {
			setModalStatuses({ ...modalStatuses, show: false })
		}
	}

	async function changeProductsStatus(item, status) {
		var sendData = {
			id: item.id,
			status: status
		}
		console.log(item);

		if (item.product_type) sendData.product_type = item.product_type;
		const response = await PUT(`/cheques-products-status`, sendData, { loader: true })
		if (httpOk(response)) {
			setModalStatuses({ ...modalStatuses, show: false })
			searchWithFilter()
		}
	}

	function toggleModalCouriers(bool, item) {
		if (bool) {
			setModalCouriers({ ...modalCouriers, show: true, item: item })

		} else {
			setModalCouriers({ ...modalCouriers, show: false })
		}
	}

	async function changeCourier(item, login) {
		var sendData = {
			id: item.id,
			courier_login: login
		}
		const response = await PUT(`/cheques-courier`, sendData, { loader: true })
		if (httpOk(response)) {
			setModalCouriers({ ...modalCouriers, show: false })
			searchWithFilter()
		}
	}

	function resetFilter() {
		var filterDataCopy = {
			start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
			end_date: formatDate(new Date(), 'yyyy-MM-dd'),
			status: null,
			cashier_login: null,
			search: '',
			random: filterData.random + 1
		}
		setFilterData(filterDataCopy)
	}

	async function checkFilter() {
		// if (
		// 	filterData.cashier_login === null &&
		// 	filterData.status === null &&
		// 	filterData.start_date === null &&
		// 	filterData.end_date === null &&
		// 	filterData.search === ''
		// ) {
		// 	setFilterDataExist(false)
		// }
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	async function getPaymentTypes() {
		const response = await GET('/helper/payment-types')
		if (httpOk(response)) setPaymentTypes(response.data)
	}

	async function getProductStatuses() {
		const response = await GET('/helper/product-statuses')
		if (httpOk(response)) setProductStatuses(response.data)
	}

	async function getClients() {
		const response = await GET('/helper/clients')
		if (httpOk(response)) setClients(response.data)
	}

	async function getCouriers() {
		const response = await GET('/helper/couriers')
		if (httpOk(response)) setCouriers(response.data)
	}

	useEffect(() => {
		getPaymentTypes()
		getProductStatuses()
		getClients()
		getCouriers()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.page, filterData.random, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const today = new Date();
		let newStartDate = null;
		let newEndDate = null;

		const getStartOfWeek = (date) => {
			const d = new Date(date);
			const day = d.getDay();
			const diff = d.getDate() - day + (day === 0 ? -6 : 1);
			return new Date(d.setDate(diff));
		};

		const getEndOfWeek = (date) => {
			const d = new Date(date);
			const startOfWeek = getStartOfWeek(d);
			const endOfWeek = new Date(startOfWeek);
			endOfWeek.setDate(startOfWeek.getDate() + 6);
			return endOfWeek;
		};

		switch (filterData.chequeDates) {
			case 'today':
				newStartDate = formatDate(today, 'yyyy-MM-dd');
				newEndDate = formatDate(today, 'yyyy-MM-dd');
				break;
			case 'currentWeek':
				const startOfCurrentWeek = getStartOfWeek(today);
				const endOfCurrentWeek = getEndOfWeek(today);
				newStartDate = formatDate(startOfCurrentWeek, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfCurrentWeek, 'yyyy-MM-dd');
				break;
			case 'currentMonth':
				const startOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
				const endOfCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
				newStartDate = formatDate(startOfCurrentMonth, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfCurrentMonth, 'yyyy-MM-dd');
				break;
			case 'currentYear':
				const startOfCurrentYear = new Date(today.getFullYear(), 0, 1);
				const endOfCurrentYear = new Date(today.getFullYear(), 11, 31);
				newStartDate = formatDate(startOfCurrentYear, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfCurrentYear, 'yyyy-MM-dd');
				break;
			case 'yesterday':
				const yesterday = new Date(today);
				yesterday.setDate(today.getDate() - 1);
				newStartDate = formatDate(yesterday, 'yyyy-MM-dd');
				newEndDate = formatDate(yesterday, 'yyyy-MM-dd');
				break;
			case 'lastWeek':
				const lastWeekEnd = new Date(today);
				lastWeekEnd.setDate(today.getDate() - 7);
				const startOfLastWeek = getStartOfWeek(lastWeekEnd);
				const endOfLastWeek = getEndOfWeek(lastWeekEnd);
				newStartDate = formatDate(startOfLastWeek, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfLastWeek, 'yyyy-MM-dd');
				break;
			case 'lastMonth':
				const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
				const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
				newStartDate = formatDate(startOfLastMonth, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfLastMonth, 'yyyy-MM-dd');
				break;
			case 'lastYear':
				const startOfLastYear = new Date(today.getFullYear() - 1, 0, 1);
				const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31);
				newStartDate = formatDate(startOfLastYear, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfLastYear, 'yyyy-MM-dd');
				break;
			case 'other':
				newStartDate = filterData.start_date;
				newEndDate = filterData.end_date;
				break;
			default:
				newStartDate = null;
				newEndDate = null;
				break;
		}

		if (newStartDate !== filterData.start_date || newEndDate !== filterData.end_date) {
			setFilterData(prevFilterData => ({
				...prevFilterData,
				start_date: newStartDate,
				end_date: newEndDate,
			}));
		}
	}, [filterData.chequeDates]); // eslint-disable-line react-hooks/exhaustive-deps

	function findCurrentStatus(item) {
		if (!item || !item.groups || item.groups.length === 0) {
			return { name: null, color: null };
		}
		const groupStatusIds = [...new Set(item.groups.map(group => group.group_status))];
		const relevantProductStatuses = productStatuses.filter(status =>
			groupStatusIds.includes(status.id)
		);
		if (relevantProductStatuses.length === 0) {
			return { name: null, color: null };
		}
		const minStatus = relevantProductStatuses.reduce((min, current) => {
			return (current.order_number < min.order_number) ? current : min;
		});
		return {
			name: minStatus.name,
			color: minStatus.color
		};
	}

	return (
		<>
			<div className="page-header d-between mb-2">
				<h4 className="vertical-center">
					{t('cheques')} [{data?.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('clients')}</label>
												<Select
													isClearable
													options={clients}
													value={clients.find(option => option.id === filterData.client_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'client_id': option?.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-6">
												<label>{t('payment')}</label>
												<Select
													isClearable
													options={paymentTypes}
													value={paymentTypes.find(option => option.id === filterData.payment_type_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'payment_type_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={productStatuses}
													value={productStatuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-6">
												<label>{t('cheque')} ID</label>
												<input type="text" className="form-control"
													onChange={(e) => setFilterData({ ...filterData, 'id': e.target.value })} />
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('shift')} ID</label>
												<input type="text" className="form-control"
													onChange={(e) => setFilterData({ ...filterData, 'shift_id': e.target.value })} />
											</div>
											<div className="form-group col-md-6">
												<label>{t('client')} {t('phone')}</label>
												<input type="text" className="form-control"
													onChange={(e) => setFilterData({ ...filterData, 'client_phone': e.target.value })} />
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('period')}</label>
												<Select
													options={chequeDates}
													// value={chequeDates.find(option => option.id === filterData.status) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'chequeDates': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-4">
												<label className="invisible">{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-4">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter()}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
						<div className="vertical-center">
							<h4 className="text-end">
								<b>{t('amount')}</b>: {formatMoney(data.total_amount)}
							</h4>
						</div>
					</div>

					{true &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', filterData.status, 'name')}
									</span>
								}
								{filterData.cheque_type &&
									<span className="me-2">
										<b>{t('cheque_type')}: </b>
										{findKeyFromArrayByValue(chequeTypes, 'id', filterData.cheque_type, 'name')}
									</span>
								}
								{filterData.id &&
									<span className="me-2">
										<b>ID: </b> {filterData.id}
									</span>
								}
								{filterData.shift_id &&
									<span className="me-2">
										<b>{t('shift')} ID: </b> {filterData.shift_id}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={() => resetFilter()}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '10%' }}>{t('cashier')}</th>
									<th style={{ 'width': '10%' }}>{t('courier')}</th>
									<th style={{ 'width': '5%' }} className=" text-center">{t('cheque')} №</th>
									<th style={{ 'width': '10%' }}>{t('client')}</th>
									<th style={{ 'minWidth': '115px' }} className="text-center">{t('phone')}</th>
									<th style={{ 'width': '15%' }} className="text-center">{t('type')}</th>
									<th style={{ 'minWidth': '175px' }} className="text-center">{t('status')}</th>
									<th style={{ 'minWidth': '130px' }} className="text-center">{t('groups')}</th>
									<th style={{ 'minWidth': '130px' }} className="text-center">{t('open_date')}</th>
									<th style={{ 'minWidth': '130px' }} className="text-center">{t('close_date')}</th>
									<th style={{ 'minWidth': '115px' }} className="text-end">{t('amount')}</th>
									<th style={{ 'minWidth': '33px' }} className="text-center"></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<Fragment key={index}>
										<tr>
											<td className="text-center" title={item.id}>
												{item.row_number}
											</td>
											<td className="td-ellipsis">{item.cashier_name}</td>
											<td className="td-ellipsis">{item.courier_name}</td>
											<td className="text-center">{item.id}</td>
											<td className="td-ellipsis">{item.client_name}</td>
											<td className="td-ellipsis text-center">{regexPhoneNumber(item.client_phone)}</td>
											<td className="text-center">{item.client_type_name}</td>
											<td className="text-center text-white cursor" onClick={() => toggleModalStatuses(true, item)}
												style={{ backgroundColor: findCurrentStatus(item)?.color }}>
												{findCurrentStatus(item)?.name}
											</td>
											<td className="text-center">
												<div className="d-flex gap-3">
													{item.groups.map((item2, index2) => (
														productImages.find(type => type.id === item2.product_type_id)?.id &&
														<CustomTooltip text={`${item2.name}: ${item2.total_count}`} key={index2}>
															<div onClick={() => toggleModalStatuses(true, item, item2)}>
																{item2.product_type_id === 4 && <ProductType4 fill={item2.color} />}
																{item2.product_type_id === 3 && <ProductType3 fill={item2.color} />}
																{item2.product_type_id === 5 && <ProductType5 fill={item2.color} />}
																{item2.product_type_id === 1 && <ProductType1 fill={item.color} />}
															</div>
															{/* {productImages.find(type => type.id === item2.product_type_id)?.image} */}
															{/* <img src={productImages.find(type => type.id === item2.product_type_id)?.image} alt="" /> */}
														</CustomTooltip>
													))
													}
												</div>
											</td>
											<td className={`text-center ${Number(item.total_amount) - Number(item.paid) < 0 ? 'bg-danger text-white' : ''}`}>
												{formatDate(item.cheque_opened_at, 'dd.MM.yyyy HH:mm')}
											</td>
											<td className="text-center">
												{formatDate(item.cheque_closed_at, 'dd.MM.yyyy HH:mm')}
											</td>
											<td className={`text-end text-nowrap`}>
												{formatMoney(item.total_amount)}
											</td>
											<td className="py-0" style={{ verticalAlign: 'middle' }}>
												<div className="d-flex justify-content-end">
													<div className="table-dropdown-item" onClick={() => printCheque(item)}>
														<CustomTooltip text={t('print')}>
															<i className="uil-print me-1"></i>
														</CustomTooltip>
													</div>
													<div className="table-dropdown-item" onClick={() => printCheque(item, true)}>
														<CustomTooltip text={`${t('print')} A4`}>
															<i className="uil-print me-1"></i>
														</CustomTooltip>
													</div>
													<div className="table-dropdown-item" onClick={() => toggleModalCouriers(true, item)}>
														<CustomTooltip text={t('courier')}>
															<i className={`uil-truck me-1 ${item.courier_login ? 'text-success' : ''}`}></i>
														</CustomTooltip>
													</div>
												</div>
											</td>
										</tr>
									</Fragment>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<Modal
				show={modalStatuses.show} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalStatuses(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('status')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{productStatuses.map((item, index) => (
						<div className="addition-wrapper-item" style={{ backgroundColor: item.color }} key={index} onClick={() => changeProductsStatus(modalStatuses.item, item.id)}>
							{item.name}
						</div>
					))}
				</Modal.Body>
			</Modal>

			<Modal
				show={modalCouriers.show} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalCouriers(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('courier')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{couriers.map((item, index) => (
						<div className="addition-wrapper-item" key={index} onClick={() => changeCourier(modalCouriers.item, item.login)}>
							{item.name}
						</div>
					))}
				</Modal.Body>
			</Modal>

			<Cheque data={printData} printChequeRef={printChequeRef} />
		</>
	)
}

export default Index
